import { call, put, takeLatest } from "redux-saga/effects";
import {
  onAdminLogin,
  onAdminLoginSuccess,
  onAdminLoginError,
} from "../Store/Slices/adminLoginSlice";
import { callAdminLoginApi } from "../Context/loginUser";

function* adminLoginSagaWorker({ payload }) {
  try {
    const response = yield call(callAdminLoginApi, {
      ...payload,
      user_type: "admin",
    });
    const code = response?.httpStatusCode ?? response?.status ?? response?.status_code;
    const ok = code === 200 || code === "200";

    if (ok) {
      yield put(
        onAdminLoginSuccess({
          data: response?.data ?? response,
          message: response?.message ?? "Login successful",
          status_code: code ?? 200,
        })
      );
      return;
    }

    yield put(
      onAdminLoginError({
        data: response?.data ?? null,
        message: response?.message ?? "Login failed",
        status_code: code ?? 400,
      })
    );
  } catch (error) {
    const message =
      error?.response?.data?.message ?? error?.message ?? "Something went wrong";
    yield put(onAdminLoginError({ data: null, message, status_code: 400 }));
  }
}

export default function* adminLoginSaga() {
  yield takeLatest(onAdminLogin.type, adminLoginSagaWorker);
}
